export const ZOOM = {
  DEFAULT: 10,
  MIN: 2,
  MAX: 18,
};

// Padding used for fitting the map viewport to results (getViewportProps) and for
// change-detection / viewport upkeep (getPaddedBounds). It must stay symmetric top/bottom and
// left/right: an asymmetric value makes the post-search recenter (fitBounds) drift the map toward
// the heavier side, which drops pins near the opposite edge even though they're still on screen.
// The old mobile bottom:240 dated from a layout where a results sheet covered the bottom of the
// map; the map is now fullscreen with auto-search, so it's symmetric like desktop.
export const PADDING = {
  mobile: {
    top: 70,
    bottom: 70,
    right: 70,
    left: 70,
  },
  desktop: {
    top: 70,
    bottom: 70,
    right: 70,
    left: 70,
  },
};

export const REFIT_PADDING = 0.05;
